var siteBaseUrl = "https://soccerzone-usa-warehouse.myshopify.com/";
var appBaseUrl = "https://app.soccerzoneusa.com/";
var userReferenceId;
var currentlySelected = getCookie("currentlySelected");
var previouslySelected = getCookie("previouslySelected");
var overallSelected = getCookie("overallSelected");
var playerPageLoad = false;
//alert("js file = "+currentlySelected);


function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}


function randomStr(len, arr) {
    var ans = '';
    for (var i = len; i > 0; i--) {
        ans += arr[Math.floor(Math.random() * arr.length)];
    }
    return ans;
}
userReferenceId = getCookie("userReferenceId");
if (userReferenceId == "") {
    userReferenceId = Date.now() + "-" + randomStr(15, '1234567890abcdefghijklmnopqrstuvwxyz');
    document.cookie = "userReferenceId=" + userReferenceId + ";path=/";
}

function showEmptyPlayersWarning() {
    alert("Warning: You have not selected any players");
}

Handlebars.registerHelper('ifEquals', function(arg1, arg2) {
    return (arg1 == arg2) ? (this) : !(this);
});
Handlebars.registerHelper("setVar", function(varName, varValue, options) {
    options.data.root[varName] = varValue;
});


Handlebars.registerHelper('ifNotEmpty', function(arg1) {
    return (arg1 >= 0) ? (this) : !(this);
});

Handlebars.registerHelper("inc", function(varName, varvalue, options)
{
  options.data.root[varName] = parseInt(varvalue) + 1;
});